<div class="search-result-container">
  <div fxLayout="row">
    <div class="header-bar" fxLayout="column" fxFlex="100" fxLayoutGap="20px">
      <div class="back-btn" (click)="onBackClick()">
        <img src="assets/images/back.svg" alt="" />
        Back
      </div>
      <div class="header-text">Search Result</div>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="column" fxFlex="100">
      <app-search-result-table headerTheme="light-blue" [columnHeaders]="resultHeader" [data]="searchResult"
        [tableAttributes]="resultAttributes">
      </app-search-result-table>
    </div>
  </div>
</div>